	 <h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >

       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">

<div class="detail-panel link" *ngFor="let document of watchers" appMargin marginB="10">
	<div fxLayout="row" fxLayoutAlign='space-between center'>
		<div fxFlex="auto">
			     <img src="{{document.jpaAppUser.image}}" class="ui circular tiny image">
		</div>
		<div fxFlex="grow">
			<h4 class="sub-header">{{document?.jpaAppUser?.firstName}} {{document?.jpaAppUser?.lastName}} {{document?.jpaAppUser?.middleName}}</h4>
			<!-- <div class="sub-item">Created By <label class="ui circular link grey label">{{document?.createdBy}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; Last Edited <label class="ui circular link grey label">{{document?.dateCreated}}</label></div> -->
		</div>
	</div>
</div>

       </div>
 </div>
      <div  class="actions">
    <!-- <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button> -->
            <button class="ui  primary button"  (click)="modal.deny(undefined)" autofocus>Close </button>

      </div>


